export function EditImage (pEditor, pImage)
{
  this.showImageSettingsToolBar = () =>
  {
    let params,
        borderWidth,
        naturalRatioHeight,
        imageObject,
        currentImage = pImage.getCurrentImage();

    if (!currentImage && pImage.execCurrentImage)
    {
      imageObject = pImage.objectFactory.getImageObject(pImage.execCurrentImage);
      pImage.execCurrentImage = null;

      if (imageObject)
      {
        imageObject.object.select(true);
        currentImage = pImage.getCurrentImage();
      }
    }

    if (currentImage)
    {
      borderWidth = currentImage.style.borderTopWidth || currentImage.style.borderRightWidth || currentImage.style.borderBottomWidth || currentImage.style.borderLeftWidth || currentImage.getAttribute('border');
      naturalRatioHeight = currentImage.offsetWidth / (currentImage.naturalWidth / currentImage.naturalHeight);

      params =
      {
        size:
        {
          contentWidth: pEditor.cutBox.offsetWidth,
          contentHeight: pEditor.cutBox.offsetHeight,
          isOriginal: (currentImage.offsetWidth === currentImage.naturalWidth && currentImage.offsetHeight === currentImage.naturalHeight),
          originalWidth: currentImage.naturalWidth,
          originalHeight: currentImage.naturalHeight,
          width: currentImage.offsetWidth,
          height: currentImage.offsetHeight,
          keepRatio: (currentImage.offsetHeight === Math.floor(naturalRatioHeight) || currentImage.offsetHeight === Math.round(naturalRatioHeight))
        },
        margins:
        {
          top: ((currentImage.style.marginTop && !isNaN(parseInt(currentImage.style.marginTop))) ? parseInt(currentImage.style.marginTop) : 0),
          right: ((currentImage.style.marginRight && !isNaN(parseInt(currentImage.style.marginRight))) ? parseInt(currentImage.style.marginRight) : 0),
          bottom: ((currentImage.style.marginBottom && !isNaN(parseInt(currentImage.style.marginBottom))) ? parseInt(currentImage.style.marginBottom) : 0),
          left: ((currentImage.style.marginLeft && !isNaN(parseInt(currentImage.style.marginLeft))) ? parseInt(currentImage.style.marginLeft) : 0)
        },
        wrapping: pImage.imageSettings.ImageWrappingType.ImageInlineWithText,
        addLinkToOriginal: !!pImage.getThumbnailLink(currentImage),
        altText: (currentImage.alt != null && currentImage.alt !== '') ? currentImage.alt : (currentImage.title != null && currentImage.title !== '') ? currentImage.title : '',
        borders:
        {
          width: ((borderWidth && !isNaN(parseInt(borderWidth))) ? parseInt(borderWidth) : 0),
          color: '#'+ BEditor.utils.convertColorToHex(BEditor.styleHelpers.getElementStyle(currentImage, 'borderTopColor')) || null
        }
      };

      this.hideImageSettingsToolBar();
      pImage.imageSettings.showToolbar(currentImage, params);
    }
    
    pImage.currentImage = currentImage;
  };


  this.hideImageSettingsToolBar = () =>
  {
    pImage.imageSettings.hideToolbar();
  };


  this.setImageProperty = args =>
  {
    var propertyHandlers =
    {
      'size': setSize,
      'margins': setMargins,
      'wrapping': setWrapping,
      'addLinkToOriginal': setLinkToOriginal,
      'altText': setAltText,
      'borders': setBorders
    },

    valueList,
    prevCurrentImage = pImage.currentImage;

    valueList = args.value;
    pImage.currentImage = pImage.getCurrentImage();

    if (!pImage.currentImage && prevCurrentImage)
    {
      pImage.currentImage = prevCurrentImage;
    }

    if (!pImage.currentImage)
    {
      return false;
    }

    propertyHandlers[args.name](args.value[args.name]);


    function setSize (value)
    {
      var isBigWidth = (value.width > pEditor.cutBox.offsetWidth);

      pImage.currentImage.setAttribute('width', value.width);
      pImage.currentImage.setAttribute('height', value.height);

      if (pImage.currentImage.style.width)
      {
        pImage.currentImage.style.width = value.width + 'px';
      }

      if (valueList.size.keepRatio)
      {
        pImage.currentImage.style.height = '';
      }
      else
      {
        pImage.currentImage.style.height = value.height + 'px';
      }

      if (isBigWidth)
      {
        pImage.currentImage.style.maxWidth = 'none';
      }
      else
      {
        pImage.currentImage.style.maxWidth = ''
      }
    }


    function setMargins (value)
    {
      pImage.currentImage.style.marginTop = ((value.top !== null) ? value.top + 'px' : '');
      pImage.currentImage.style.marginRight = ((value.right !== null) ? value.right + 'px' : '');
      pImage.currentImage.style.marginBottom = ((value.bottom !== null) ? value.bottom + 'px' : '');
      pImage.currentImage.style.marginLeft = ((value.left !== null) ? value.left + 'px' : '');
    }


    function setWrapping (value)
    {
      pImage.currentImage.style.textAlign = '';

      if (value !== pImage.imageSettings.ImageWrappingType.ImageCenteredTextBreaks)
      {
        if (pImage.currentImage.style.marginLeft === 'auto' && pImage.currentImage.style.marginRight === 'auto')
        {
          pImage.currentImage.style.marginLeft = '';
          pImage.currentImage.style.marginRight = '';
        }
      }

      if (value === pImage.imageSettings.ImageWrappingType.ImageInlineWithText || value === pImage.imageSettings.ImageWrappingType.ImageRightTextWrapsLeft || value === pImage.imageSettings.ImageWrappingType.ImageLeftTextWrapsRight)
      {
        if (pImage.currentImage.style.display === 'block' || pImage.currentImage.style.display === 'fixed')
        {
          pImage.currentImage.style.display = '';
        }

        if (value === pImage.imageSettings.ImageWrappingType.ImageInlineWithText)
        {
          pImage.currentImage.removeAttribute('align');
        }
        else
        {
          pImage.currentImage.setAttribute('align', ((value === pImage.imageSettings.ImageWrappingType.ImageRightTextWrapsLeft) ? 'right' : 'left'));
        }
      }
      else
      {
        pImage.currentImage.removeAttribute('align');

        if (value === pImage.imageSettings.ImageWrappingType.ImageCenteredTextBreaks)
        {
          pImage.currentImage.style.marginLeft = 'auto';
          pImage.currentImage.style.marginRight = 'auto';
        }

        pImage.currentImage.style.display = 'block';
      }
    }


    function setLinkToOriginal (value)
    {
      var aNode,
          imageObject,
          title,
          alt;

      if (value)
      {
        if (pImage.currentImage.parentNode.nodeName !== 'A')
        {
          aNode = pEditor.iFrameDoc.createElement('A');
          aNode.setAttribute('href', pImage.currentImage.getAttribute('src').replace(/\?width=\d+&height=\d+/i, ''));
          alt = pImage.currentImage.getAttribute('alt');
          title = pImage.currentImage.getAttribute('title');
          aNode.setAttribute('title', ((title != null && title !== '') ? title : ((alt != null && alt !== '') ? alt : '')));
          pImage.currentImage.removeAttribute('title');
          aNode.setAttribute('target', '_blank');

          if (BEditor.browser.isGecko)
          {
            aNode.setAttribute('data-wasetlinktooriginal', '1');
          }

          pImage.currentImage.parentNode.insertBefore(aNode, pImage.currentImage);
          aNode.appendChild(pImage.currentImage);
        }
      }
      else
      {
        if (pImage.currentImage.parentNode.nodeName === 'A')
        {
          alt = pImage.currentImage.getAttribute('alt');
          title = pImage.currentImage.parentNode.getAttribute('title');
          pImage.currentImage.setAttribute('title', ((title != null && title !== '') ? title : ((alt != null && alt !== '') ? alt : '')));
          pImage.currentImage.parentNode.parentNode.replaceChild(pImage.currentImage, pImage.currentImage.parentNode);
        }
      }

      if(pImage.currentImage)
      {
        imageObject = pImage.objectFactory.getImageObject(pImage.currentImage);

        if (imageObject)
        {
          imageObject.object.select(true);
        }
      }
    }


    function setAltText (value)
    {
      pImage.currentImage.setAttribute('alt', value);

      if (valueList.addLinkToOriginal && pImage.currentImage.parentNode.nodeName === 'A')
      {
        pImage.currentImage.parentNode.setAttribute('title', value);
      }
      else
      {
        pImage.currentImage.setAttribute('title', value);
      }
    }


    function setBorders (value)
    {
      var borderWidth = (pImage.currentImage.style.borderTopWidth || pImage.currentImage.style.borderRightWidth || pImage.currentImage.style.borderBottomWidth || pImage.currentImage.style.borderLeftWidth);

      if (borderWidth)
      {
        pImage.currentImage.style.borderWidth = value.width + 'px';
      }
      else
      {
        pImage.currentImage.setAttribute('border', value.width);
      }

      pImage.currentImage.style.borderColor = value.color;
    }


    function setRotation (direction)
    {
      var currentClass = pImage.currentImage.getAttribute('class') || '',
          angle,
          isClassExists = false;

      if (currentClass && (/transformRotate\d{2,3}deg/i).test(currentClass))
      {
        angle = parseInt(currentClass.replace(/transformRotate(\d{2,3})deg/i, '$1'));
        isClassExists = true;
      }
      else
      {
        angle = (direction === 'Left') ? 360 : 0;
      }

      angle += (direction === 'Left') ? -90 : 90;

      if (angle === 90 || angle === 180 || angle === 270)
      {
        if (isClassExists)
        {
          currentClass = currentClass.replace(/transformRotate\d{2,3}deg/i, 'transformRotate' + angle + 'deg');
        }
        else
        {
          currentClass += (currentClass.length ? ' ' : '') + 'transformRotate' + angle + 'deg';
        }

        pImage.currentImage.setAttribute('class', currentClass);
      }
      else
      {
        if (currentClass.length)
        {
          currentClass = currentClass.replace(/transformRotate\d{2,3}deg\s*/i, '').replace(/\s+$/, '');
        }

        if (currentClass.length)
        {
          pImage.currentImage.setAttribute('class', currentClass);
        }
        else
        {
          pImage.currentImage.removeAttribute('class');
        }
      }
    }
  };


  this.onImageSettingsToolBarClosed = (sender, args) =>
  {
    waMetricsGlobalHandler({module: 'InsertResourceDialog', object: 'ImageDialog', operation: 'Change'});
  };
}